import { useTranslation } from 'react-i18next'

interface Feature {
  icon: string
  titleKey: string
  descriptionKey: string
}

const features: Feature[] = [
  {
    icon: 'fas fa-user-graduate',
    titleKey: 'landing.features.items.personalLearning.title',
    descriptionKey: 'landing.features.items.personalLearning.description',
  },
  {
    icon: 'fas fa-book-open',
    titleKey: 'landing.features.items.materials.title',
    descriptionKey: 'landing.features.items.materials.description',
  },
  {
    icon: 'fas fa-tasks',
    titleKey: 'landing.features.items.organizer.title',
    descriptionKey: 'landing.features.items.organizer.description',
  },
  {
    icon: 'fas fa-chart-pie',
    titleKey: 'landing.features.items.finance.title',
    descriptionKey: 'landing.features.items.finance.description',
  },
  {
    icon: 'fas fa-calendar-check',
    titleKey: 'landing.features.items.schedule.title',
    descriptionKey: 'landing.features.items.schedule.description',
  },
  {
    icon: 'fas fa-clipboard-check',
    titleKey: 'landing.features.items.tests.title',
    descriptionKey: 'landing.features.items.tests.description',
  },
  {
    icon: 'fas fa-history',
    titleKey: 'landing.features.items.history.title',
    descriptionKey: 'landing.features.items.history.description',
  },
  {
    icon: 'fas fa-route',
    titleKey: 'landing.features.items.program.title',
    descriptionKey: 'landing.features.items.program.description',
  },
  {
    icon: 'fas fa-brain',
    titleKey: 'landing.features.items.smart.title',
    descriptionKey: 'landing.features.items.smart.description',
  },
]

export function Features() {
  const { t } = useTranslation()

  return (
    <section className="features" id="features">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">{t('landing.features.title')}</h2>
          <p className="section-subtitle">
            {t('landing.features.subtitle')}
          </p>
        </div>
        <div className="features-grid">
          {features.map((feature, index) => (
            <div key={index} className="feature-card">
              <div className="feature-icon">
                <i className={feature.icon}></i>
              </div>
              <h3>{t(feature.titleKey)}</h3>
              <p>{t(feature.descriptionKey)}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
